module.exports = __webpack_public_path__ + "media/images/top/pap/icon/white/ico_check-3a95f98b87a6d57cac37a5c869099c93.svg";